import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import CourseProgressFormFonts from './CourseProgressFormFont'
import CourseProgressFormStyle from './CourseProgressFormStyle'
import type { CourseProgressFormBrandType, CourseProgressBrandForms } from './courseProgressTypes'

const FORM_MAP: CourseProgressBrandForms = {
  [BrandFormEnum.STYLE]: CourseProgressFormStyle,
  base: CourseProgressFormFonts,
}

const CourseProgressFormBrand: CourseProgressFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(CourseProgressFormBrand) as typeof CourseProgressFormBrand
